<template>
  <div class="grid column-gap grid-2-columns@sm">
    <div class="mb-2">
      <label>
        <small>
          Start
          <span v-if="!start" class="color-red">*</span>
        </small>
        <input v-if="start" :value="round.start | date('YYYY-MM-DD HH:mm')" disabled />
        <flat-pickr
          v-model="round.start"
          v-else
          :config="roundStartConfig"
          :disabled="disabled"
          required
        />
      </label>
      <small v-if="$v.round.start.$error" class="color-red">
        <template v-show="!$v.round.start.required">
          This field is required.&nbsp;
        </template>
      </small>
    </div>

    <div class="mb-2">
      <label>
        <small>
          End
          <span class="color-red">*</span>
        </small>
        <flat-pickr v-model="round.end" :config="roundEndConfig" :disabled="disabled" required />
      </label>
      <small v-if="$v.round.end.$error" class="color-red">
        <template v-show="!$v.round.end.required">
          This field is required.&nbsp;
        </template>
        <template v-show="!$v.round.end.hourApart">
          Round must last at least 1 hour.
        </template>
      </small>
    </div>
  </div>
</template>

<script>
import { required } from "@/utils/validators"
import differenceInHours from "date-fns/difference_in_hours"

const hourApart = (start, end) => () => {
  if (!start || !end) return true
  return differenceInHours(end, start) >= 1
}

export default {
  props: {
    start: Date,
    duration: Number,
    disabled: Boolean
  },

  data: () => ({
    round: {
      start: "",
      end: ""
    }
  }),

  computed: {
    roundStartConfig() {
      let latestStart = null
      if (this.round.end) {
        const date = new Date(this.round.end)
        latestStart = date.setHours(date.getHours() - 1)
      }

      return {
        minDate: Date.now(),
        maxDate: latestStart,
        enableTime: true,
        defaultHour: 0
      }
    },

    roundEndConfig() {
      const earliestEnd = this.round.start ? new Date(this.round.start) : new Date()
      earliestEnd.setHours(earliestEnd.getHours() + 1)

      const latestEnd = this.round.start ? new Date(this.round.start) : new Date()
      latestEnd.setYear(latestEnd.getFullYear() + 1)

      return {
        minDate: earliestEnd,
        maxDate: latestEnd,
        enableTime: true,
        defaultHour: 0
      }
    }
  },

  watch: {
    round: {
      handler(round) {
        this.$emit("dateChange", {
          start: new Date(round.start),
          duration: new Date(round.end) - new Date(round.start)
        })
      },
      deep: true,
      immediate: true
    },

    "$v.$invalid": function(invalid) {
      this.$emit("invalid", invalid)
    }
  },

  created() {
    this.reset()
  },

  methods: {
    reset() {
      this.round.start = ""
      this.round.end = ""

      if (this.start) {
        this.round.start = this.start
        this.round.start.setSeconds(0)
        this.round.start.setMilliseconds(0)

        if (this.duration) {
          this.round.end = new Date(+this.round.start + this.duration)
        }
      }
    }
  },

  validations() {
    return {
      round: {
        start: {
          required
        },
        end: {
          required,
          hourApart: hourApart(this.round.start, this.round.end)
        }
      }
    }
  }
}
</script>
